import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { HomologationBatchExportService } from '../../services/homologation-batch-export.service';

@Component({
  selector: 'app-homologation-batch-export-progress',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './homologation-batch-export-progress.component.html',
  styleUrl: './homologation-batch-export-progress.component.scss',
})
export class HomologationBatchExportProgressComponent {
  readonly batchExportService = inject(HomologationBatchExportService);
  readonly state$ = this.batchExportService.state$;

  getProgress(processed: number, total: number): number {
    if (!total) {
      return 0;
    }

    return Math.round((processed / total) * 100);
  }

  close(): void {
    this.batchExportService.closeProgress();
  }
}
